// src/UserResultsPage.tsx
//
// Stránka /results: karty probíhajících (LIVE) a nedávno ukončených live
// závodů nad seznamem výsledků. Seznam závodů dává useRaces – seznam z paměti
// relace se ukáže hned a při každém otevření stránky se načte znovu, jedním
// dotazem sdíleným s UserResults (dřív se kolekce na jedné stránce četla
// dvakrát); karty tak odpovídají aktuálnímu stavu závodu. Titulek „Výsledky"
// dodává Screen v App.tsx.

import React, { useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InfoCard } from "./ui/Cards";
import { selectLiveRaces, useRaces, type Race } from "./utils/useRaces";
import UserResults, { type OpenRaceRequest } from "./UserResults";

const UserResultsPage: React.FC = () => {
  const navigate = useNavigate();
  const { allRaces } = useRaces();
  // Jen veřejné tabule (livePublic) – i u ukončených závodů (plán kroku 7)
  const { live, finished } = useMemo(() => selectLiveRaces(allRaces), [allRaces]);

  const [openRequest, setOpenRequest] = useState<OpenRaceRequest | null>(null);
  const requestToken = useRef(0);

  const openDisplay = (race: Race) => navigate(`/display/${race.id}`);

  /**
   * Ukončený závod: publikované výsledky se rozbalí v seznamu níže (filtr
   * kategorie, zvýraznění vlastního řádku); do publikace vede odkaz na
   * finální live tabuli, jinde zatím výsledky nejsou.
   */
  const showFinalResults = (race: Race) => {
    if (race.resultsPublishedCount > 0) {
      requestToken.current += 1;
      setOpenRequest({ raceId: race.id, token: requestToken.current });
    } else {
      openDisplay(race);
    }
  };

  return (
    <>
      {(live.length > 0 || finished.length > 0) && (
        <div className="mb-3">
          {live.map((race) => (
            <InfoCard
              key={`live-${race.id}`}
              icon="bi-broadcast"
              tone="success"
              title="Sledujte výsledky live"
              badge={<span className="badge bg-danger">LIVE</span>}
              subtitle={race.name}
              action={{
                label: "Otevřít tabuli",
                variant: "primary",
                onClick: () => openDisplay(race),
              }}
            />
          ))}
          {finished.map((race) => (
            <InfoCard
              key={`fin-${race.id}`}
              icon="bi-flag-fill"
              tone="info"
              title="Závod ukončen – výsledky jsou finální"
              subtitle={race.name}
              action={{
                label: "Výsledky",
                variant: "light",
                onClick: () => showFinalResults(race),
              }}
            />
          ))}
        </div>
      )}

      <UserResults openRequest={openRequest} />
    </>
  );
};

export default UserResultsPage;
